import { Stack, Typography, Divider, TableCell, TableCellProps } from "@mui/material";


export type HeaderCellProps = {
    text: string;
    hideDivider?: boolean
} & TableCellProps;

export function HeaderCell({
    text,
    hideDivider,
    ...rest
}: HeaderCellProps) {


    return (
        <TableCell component='th' {...rest} sx={{paddingRight: 0}}>

        <Stack direction='row' >
            <Typography variant="body2" sx={{fontWeight: 500}}>
                {text}
            </Typography>

            {
            !hideDivider && <Divider orientation="vertical" sx={{
                marginLeft: 'auto',
                minHeight: '20px',
            }} /> 
            }

        </Stack>
        </TableCell>

    )

    
}
